import { useEffect, useState } from 'react';
import { BACKEND_URL } from '../config';
import { FORUM_EMOTICONS, type ForumEmoticon } from '../utils/emoticons';

interface ForumEmoticonPickerProps {
  open: boolean;
  onToggle: () => void;
  /** Reçoit l’emoji Unicode à insérer dans la saisie Neo. */
  onSelect: (emoji: string) => void;
}

/**
 * Picker limité forums : affiche et insère des emoji.
 * La conversion emoji → smiley legacy se fait à l’envoi (invisible pour l’utilisateur Neo).
 */
export function ForumEmoticonPicker({ open, onToggle, onSelect }: ForumEmoticonPickerProps) {
  const [emoticons, setEmoticons] = useState<ForumEmoticon[]>(FORUM_EMOTICONS);

  useEffect(() => {
    let cancelled = false;
    fetch(`${BACKEND_URL}/api/emoticons?scope=forum`)
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (cancelled || !data?.emoticons?.length) return;
        setEmoticons(data.emoticons as ForumEmoticon[]);
      })
      .catch(() => { /* fallback FORUM_EMOTICONS */ });
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="forums-emoticon-wrap">
      <button
        type="button"
        className={`forums-emoticon-toggle${open ? ' active' : ''}`}
        onClick={onToggle}
        title="Insérer un émoticône"
        aria-expanded={open}
        aria-label="Insérer un émoticône"
      >
        😊
      </button>
      {open && (
        <div className="forums-emoticon-dropdown" role="listbox" aria-label="Émoticônes">
          {emoticons.map((emo) => (
            <button
              key={emo.text}
              type="button"
              className="forums-emoticon-option"
              title={emo.description}
              onClick={() => onSelect(emo.emoji)}
            >
              <span className="forums-emoticon-option-emoji">{emo.emoji}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
